import { render } from "./IconStarRoundedOutline.vue?vue&type=template&id=30087db6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconStarRoundedOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30087db6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30087db6', __exports__)) {
    api.reload('30087db6', __exports__)
  }
  
  module.hot.accept("./IconStarRoundedOutline.vue?vue&type=template&id=30087db6", () => {
    api.rerender('30087db6', render)
  })

}


export default __exports__